import React from 'react';

const CHIPS = [50, 100, 200, 300, 500, 1000];

const formatChip = (val) => (val >= 1000 ? `£${val / 1000}B` : `£${val}M`);

const BudgetInput = ({ budget, setBudget }) => {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val === '' || parseFloat(val) <= 10000) {
      setBudget(val);
    }
  };

  const selectedChip = CHIPS.find((c) => String(c) === String(budget)) ?? null;

  return (
    <div className="bi-wrap">
      <div className="bi-chips" role="group" aria-label="Quick budget options">
        {CHIPS.map((val) => (
          <button
            key={val}
            type="button"
            className={`bi-chip${selectedChip === val ? ' bi-chip--selected' : ''}`}
            onClick={() => setBudget(String(val))}
            aria-pressed={selectedChip === val}
          >
            {formatChip(val)}
          </button>
        ))}
      </div>

      <div className="bi-custom-row">
        <label htmlFor="bi-custom-input" className="ts-visually-hidden">
          Custom transfer budget in millions
        </label>
        <input
          id="bi-custom-input"
          type="number"
          value={budget}
          onChange={handleChange}
          max={10000}
          placeholder="or enter a custom amount"
          className="bi-custom-input"
        />
        <span className="bi-unit" aria-hidden="true">M</span>
      </div>

      <p className="bi-hint">
        Most top clubs spend around £100M–£300M in a busy window.
      </p>
    </div>
  );
};

export default BudgetInput;
